import React, { useContext, useEffect, useState } from "react";

export const ModalCustomHook = (props) => {
    const {
        setOpenModal,
        titleModal,
        subTitleModal,
        actionRequest,
        isLoading,
        setIsLoading,
        alert,
        setAlert,
        errorMssge,
        setErrorMssge,
        severityAlert,
        setSeverityAlert,
        clearFunction,
    } = props || {};

    const handleSubmit = () => {
        setIsLoading(true);
        actionRequest();
    };

    const closePopup = () => {
        setOpenModal(false);
        clearFunction();
        setAlert(false);
    };
    return {
        handleSubmit,
        closePopup,
        titleModal,
        subTitleModal,
        severityAlert,
        errorMssge,
        isLoading,
    };
};
